import { render } from "./detail.vue?vue&type=template&id=8f49e67e"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=8f49e67e&lang=css"

import exportComponent from "C:\\Users\\tnism\\Documents\\Projects\\MiniApp\\miniapp_wing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__